module.exports = __webpack_public_path__ + "d7cec684.svg";